import { useRestMutation, useRestQuery, UseRestMutationOptions } from 'utils/hooks/api';
import { ApiMethod } from 'services/api';

export const CREATE_ESP_ACCOUNT_URL = '/settings/espAccounts/create';
export const UPDATE_ESP_ACCOUNT_URL = '/settings/espAccounts/update';
export const DELETE_ESP_ACCOUNT_URL = '/settings/espAccounts/delete';
export const ESP_ACCOUNTS_JSON_URL = '/settings/espAccounts.json';

export const useCreateEspAccount = (options?: UseRestMutationOptions) =>
  useRestMutation(CREATE_ESP_ACCOUNT_URL, ApiMethod.post, options);
export const useUpdateEspAccount = (options?: UseRestMutationOptions) =>
  useRestMutation(UPDATE_ESP_ACCOUNT_URL, ApiMethod.post, options);
export const useDeleteEspAccount = (options?: UseRestMutationOptions) =>
  useRestMutation(DELETE_ESP_ACCOUNT_URL, ApiMethod.post, options);
export const useEspAccountsJson = () => useRestQuery(ESP_ACCOUNTS_JSON_URL);
